export const mapMetadataToHeatMap = (metadata, yeartype, selectedYear) => {
    const parsed = metadata && JSON.parse(metadata);

    if (
        parsed &&
        typeof parsed === "object" &&
        Object.keys(parsed).includes(yeartype) &&
        Object.keys(parsed).includes(selectedYear)
    ) {
        Object.keys(parsed[yeartype][selectedYear]).forEach((elem) => {
            if (
                parsed[yeartype][selectedYear][elem] &&
                parsed[yeartype][selectedYear][elem].length === 0
            ) {
                parsed[yeartype][elem] = new Array(12).fill(0);
            }
        });
        return parsed[yeartype][selectedYear];
    } else if (
        parsed &&
        typeof parsed === "object" &&
        Object.keys(parsed).includes(yeartype) &&
        !Object.keys(parsed).includes(selectedYear)
    ) {
        Object.keys(parsed[yeartype]).forEach((elem) => {
            if (parsed[yeartype][elem] && parsed[yeartype][elem].length === 0) {
                parsed[yeartype][elem] = new Array(12).fill(0);
            }
        });
        return parsed[yeartype];
    }
    return parsed || {};
};
